import './routes';

// Extends and overrides API
import './views/FrontPageView';



// WEBPACK FOOTER //
// ./~/@girder/homepage/main.js